var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
import { UitkBadgeTheme } from 'uitk-react-badge';
import * as React from 'react';
import { UitkIconSize } from 'uitk-react-icons';
import { UitkMarkSize } from 'uitk-react-mark';
import { IconMark } from '../components/common/icon-mark';
import { ActivityBadgeType } from '../common/__generated__/api';
import { ActivityBadgeTheme } from '../constants';
function getBadgeTheme(type) {
  switch (type) {
    case ActivityBadgeType.DEAL_MEMBER:
      return UitkBadgeTheme.DEAL_MEMBER;
    case ActivityBadgeType.DEAL_GENERIC:
      return UitkBadgeTheme.DEAL_GENERIC;
    case ActivityBadgeType.DEAL_ADD_ON:
      return UitkBadgeTheme.DEAL_BUNDLED;
    case ActivityBadgeType.GLOBAL_LOW_TIER:
      return UitkBadgeTheme.LOYALTY_LOW_TIER;
    default:
      return UitkBadgeTheme.DEAL_GENERIC;
  }
}
function getImageBadgeTheme(theme) {
  if (theme === ActivityBadgeTheme.DEAL_MEMBER) {
    return UitkBadgeTheme.DEAL_MEMBER;
  } else if (theme === ActivityBadgeTheme.DEAL_GENERIC) {
    return UitkBadgeTheme.DEAL_GENERIC;
  } else if (theme === ActivityBadgeTheme.DEAL_BUNDLED) {
    return UitkBadgeTheme.DEAL_BUNDLED;
  } else if (theme === ActivityBadgeTheme.GLOBAL_LOW_TIER) {
    return UitkBadgeTheme.LOYALTY_LOW_TIER;
  }
  return UitkBadgeTheme.DEAL_GENERIC;
}
function getMediaElement(icon, mark) {
  return React.createElement(IconMark, {
    mark: mark,
    icon: icon,
    defaultIconSize: UitkIconSize.EXTRA_SMALL,
    markSize: UitkMarkSize.EXTRA_SMALL,
    className: mark ? 'uitk-badge-mark' : 'uitk-badge-icon'
  });
}
export function getBadgeProps(type, theme, icon, mark, badgeText, styleClasses) {
  var badgeTheme = type === null ? getImageBadgeTheme(theme) : getBadgeTheme(type);
  var props = {
    theme: badgeTheme
  };
  if (icon || mark) {
    props = __assign(__assign({}, props), {
      children: getMediaElement(icon, mark)
    });
  }
  if (badgeText) {
    props = __assign(__assign({}, props), {
      text: badgeText
    });
  }
  if (styleClasses) {
    props = __assign(__assign({}, props), {
      className: styleClasses
    });
  }
  return props;
}